import { LuGitPullRequestArrow, LuReplace } from 'react-icons/lu'

import messages from '@/lib/features/SmartShares/components/ShareAssetModal/ShareAssetModal.messages'
import { SelectableShareClass, ShareClass } from '@/lib/features/SmartShares/interfaces'

import { ShareClassOption } from './SelectShareClassModal.types'

export const shareClassOptions: Array<ShareClassOption> = [
  {
    shareClass: ShareClass.EXPLICIT,
    title: messages.smartShareClassTitle.defaultMessage,
    description: messages.smartShareClassDescription.defaultMessage,
    Icon: LuGitPullRequestArrow,
    testId: 'share-class-card-smart-share',
  },
  {
    shareClass: ShareClass.DELEGATION,
    title: messages.delegateShareClassTitle.defaultMessage,
    description: messages.delegateShareClassDescription.defaultMessage,
    Icon: LuReplace,
    testId: 'share-class-card-delegate',
  },
]

export const getShareClassOption = (shareClass: ShareClass | null) =>
  shareClassOptions.find((option) => option.shareClass === shareClass)

/**
 * `TASK_RELATED` shares are system managed, so they are deliberately not selectable here.
 */
export const isSelectableShareClass = (value: unknown): value is SelectableShareClass =>
  shareClassOptions.some((option) => option.shareClass === value)
